import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { WhiteboardDrawingsService } from '@lemberger/whiteboards';
import {
    WhiteboardDrawingsListItemComponent
} from './whiteboard-drawings-list-item/whiteboard-drawings-list-item.component';
import { Subscription } from 'rxjs';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { PageService } from '../../../../services/page.service';
import { SidebarContentComponent } from '../../sidebar/sidebar-content-component';
import { WhiteboardSearchComponent } from './whiteboard-search/whiteboard-search.component';

@Component({
    selector: 'app-whiteboard-drawings-list',
    templateUrl: './whiteboard-drawings-list.component.html',
    styleUrls: ['./whiteboard-drawings-list.component.scss'],
    standalone: true,
    imports: [
        WhiteboardSearchComponent,
        WhiteboardDrawingsListItemComponent
    ]
})
export class WhiteboardDrawingsListComponent implements SidebarContentComponent, OnDestroy {
    @Input() bookId: number;
    @ViewChild('whiteboardList') whiteboardList: ElementRef;
    itemIdPrefix = WhiteboardDrawingsListItemComponent.idPrefix;

    whiteboardsList = [];
    subscription: Subscription;
    listEmpty = true;

    constructor(public whiteboardService: WhiteboardDrawingsService,
                public pageService: PageService,
                private applicationStateService: ApplicationStateService) {

        if (!this.applicationStateService.userData.isAdmin &&
            !this.applicationStateService.userData.isWhiteboardAuthor &&
            this.applicationStateService.userData.isTeacher) {
            this.subscription = whiteboardService.whiteboardDrawings$.subscribe((whiteboardDrawings) => {
                this.whiteboardsList = whiteboardDrawings.filter(
                    whiteboardDrawing => whiteboardDrawing.user_id === this.applicationStateService.userData.id
                );
            });
        } else {
            this.subscription = whiteboardService.whiteboardDrawings$.subscribe((whiteboardDrawings) => {
                this.whiteboardsList = whiteboardDrawings;
            });
        }

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    setListNotEmpty(): void {
        this.listEmpty = false;
    }
}
